import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

interface CategoryResponse {
  name: string;
  user_id: number;
  company_id: number;
  id: number;
}

interface SubCategoryResponse {
  name: string;
  category_id: number;
  company_id: number;
  user_id: number;
  id: number;
}

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["category"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    // getCategory: builder.query<
    //   any,
    //   { companyId: string | undefined; search: string }
    // >({
    //   query: ({ companyId, search }) => {
    //     const params = new URLSearchParams();
    //     console.log(search);
    //     if (search && search.length > 0) {
    //       params.set("search", search);
    //     }
    //     return `/category/${companyId}?${params.toString()}`;
    //   },
    //   providesTags: ["category"],
    // }),
    getCategoryById: builder.query<any, string>({
      query: (id) => `/category/${id}`,
      providesTags: ["category"],
    }),
    getAllCategory: builder.query<CategoryResponse[], void>({
      query: () => `/category`,
      providesTags: ["category"],
    }),
    createCategory: builder.mutation<void, any>({
      query: (input) => ({
        url: `/category`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["category"],
    }),
    updateCategory: builder.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/category/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["category"],
    }),
    deleteCategory: builder.mutation<void, number>({
      query: (id) => ({
        url: `/category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["category"],
    }),

    // getSubCategory: builder.query<any, { categoryId: number; search: string }>({
    //   query: ({ categoryId, search }) => {
    //     const params = new URLSearchParams();
    //     console.log(search);
    //     if (search && search.length > 0) {
    //       params.set("search", search);
    //     }
    //     return `/subcategory/list/${categoryId}?${params.toString()}`;
    //   },
    //   providesTags: ["category"],
    // }),

    getSubCategoryById: builder.query<any, any>({
      query: (id) => `/sub-category/${id}`,
      providesTags: ["category"],
    }),
    getSubCategoryByCategoryId: builder.query<SubCategoryResponse[], number>({
      query: (id) => `/sub-category/category/${id}`,
      providesTags: ["category"],
    }),
    createSubCategory: builder.mutation<void, any>({
      query: (input) => ({
        url: `/sub-category`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["category"],
    }),
    updateSubCategory: builder.mutation<void, any>({
      query: ({ id, data }) => ({
        url: `/sub-category/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["category"],
    }),
    deleteSubCategory: builder.mutation<void, number>({
      query: (id) => ({
        url: `/sub-category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["category"],
    }),

    getStock: builder.query({
      query: (id) => `/stock/list/${id}`,
      providesTags: ["category"],
    }),
    getStockById: builder.query<any, any>({
      query: (id) => `/stock/${id}`,
      providesTags: ["category"],
    }),
    createStock: builder.mutation<void, any>({
      query: (input) => ({
        url: `/stock`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["category"],
    }),
    updateStock: builder.mutation<void, any>({
      query: ({ id, data }) => ({
        url: `/stock/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["category"],
    }),
    deleteStock: builder.mutation<void, number>({
      query: (id) => ({
        url: `/stock/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["category"],
    }),
  }),
});

export const {
  useGetAllCategoryQuery,
  useGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetSubCategoryByIdQuery,
  useCreateSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useDeleteSubCategoryMutation,
  useGetSubCategoryByCategoryIdQuery,
  useLazyGetSubCategoryByCategoryIdQuery,
  useGetStockByIdQuery,
  useCreateStockMutation,
  useDeleteStockMutation,
  useGetStockQuery,
  useUpdateStockMutation,
} = categoryApi;
